export type RowIdentifier = string | number;

type IdentifiableRow = {
  _id?: RowIdentifier | null;
  key?: RowIdentifier | null;
};

export function replaceRowByOriginalId<
  TRow extends IdentifiableRow,
  TSavedRow extends IdentifiableRow,
>(
  rows: readonly TRow[],
  originalRowId: RowIdentifier,
  savedRow: TSavedRow,
): Array<TRow | TSavedRow> {
  return rows.map((row) =>
    (row._id ?? row.key) === originalRowId ? savedRow : row,
  );
}
